import { enGB, fi, sv } from 'date-fns/locale';

export enum Language {
  EN = 'en',
  SE = 'se',
  FI = 'fi',
}

export enum Country {
  SE = 'SE',
  FI = 'FI',
}

export const DateFnsLocale = {
  [Language.SE]: sv,
  [Language.EN]: enGB,
  [Language.FI]: fi,
} as const;

enum IntlLocale {
  Sv = 'sv',
  Fi = 'fi',
}

export const NUMBER_FORMAT_LOCALE = IntlLocale.Sv;

export const countryLanguageConfig = {
  [Country.SE]: {
    languages: [Language.SE, Language.EN],
    defaultLanguage: Language.SE,
  },
  [Country.FI]: {
    languages: [Language.FI, Language.EN],
    defaultLanguage: Language.FI,
  },
};
